import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgUncheck6 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 82,
	height: 114,
	fill: "none",
	viewBox: "0 0 82 114",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		fillRule: "evenodd",
		stroke: "#E0E0E0",
		strokeWidth: .75,
		d: "M79.272 1H2.728c-.476 0-.91.194-1.221.507C1.194 1.82 1 2.252 1 2.73v108.54c0 .477.194.91.507 1.223.312.313.743.507 1.221.507h76.544c.476 0 .91-.194 1.221-.507.314-.313.507-.746.507-1.223V2.73c0-.477-.194-.91-.507-1.223-.312-.313-.745-.507-1.221-.507z",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#E0E0E0",
		stroke: "#E0E0E0",
		d: "M6.108 20.509h7.774v9.88H6.108v-9.88zm10.967 0h7.772v.087h-7.772v-.087zm0 3.263h18.74v.088h-18.74v-.088zm30.706-3.263h7.774v9.88H47.78v-9.88zm10.965 0h7.774v.087h-7.774v-.087zm0 3.263h18.74v.088h-18.74v-.088zM6.108 55.325h7.774v9.88H6.108v-9.88zm10.967 0h7.772v.087h-7.772v-.087zm0 3.263h18.74v.088h-18.74v-.088zm30.706-3.263h7.774v9.88H47.78v-9.88zm10.965 0h7.774v.087h-7.774v-.087zm0 3.263h18.74v.088h-18.74v-.088zM6.108 87.966h7.774v9.88H6.108v-9.88zm10.967 0h7.772v.087h-7.772v-.087zm0 3.262h18.74v.089h-18.74v-.089zm30.706-3.262h7.774v9.88H47.78v-9.88zm10.965 0h7.774v.087h-7.774v-.087zm0 3.262h18.74v.089h-18.74v-.089z"
	})]
});
export default SvgUncheck6;
